import * as Types from '../../../generated/webapp_gql';

import { gql } from 'graphql.macro';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions =  {}
export type SharedPreferencesFragment = (
  { __typename?: 'AccountSharedPreferencesRecordNode' }
  & Pick<Types.AccountSharedPreferencesRecordNode, 'key' | 'value'>
);

export type NotificationPreferencesFragment = (
  { __typename?: 'NotificationPreferencesNode' }
  & Pick<Types.NotificationPreferencesNode, 'chatNotifications' | 'courseReminders' | 'dailyPauseRemindersEmail' | 'dailyPauseRemindersPush' | 'wellBeingReminders'>
);

export type GetMemberInformationQueryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMemberInformationQueryQuery = (
  { __typename?: 'Query' }
  & { me?: Types.Maybe<(
    { __typename?: 'MemberNode' }
    & Pick<Types.MemberNode, 'id' | 'uuid' | 'defaultVisitDuration' | 'zipCode' | 'phoneNumber' | 'avatar' | 'firstName' | 'lastName' | 'email' | 'eligiblePersonEmail' | 'isActiveCobraRifMember' | 'isCompanyHpiEnabled' | 'isCompanyPsychiatryEnabled' | 'newEmailAddressNotConfirmed' | 'parentUuid' | 'isDependent' | 'birthDate' | 'localTimezone' | 'country' | 'city' | 'state' | 'languagePreferences' | 'onboardingStatus' | 'role' | 'availability' | 'emailConfirmed' | 'joinedAt' | 'registrationSource' | 'ssoOnly'>
    & { visitsRemaining?: Types.Maybe<(
      { __typename?: 'VisitsRemainingNode' }
      & Pick<Types.VisitsRemainingNode, 'therapyVisitsRemaining' | 'coachingVisitsRemaining'>
    )>, company?: Types.Maybe<(
      { __typename?: 'CompanyNode' }
      & Pick<Types.CompanyNode, 'name' | 'uuid' | 'hrEmail' | 'resetDate' | 'coveredTherapyVisits' | 'coveredCoachingVisits' | 'ssoOnly' | 'dependentInvitationFeature'>
    )>, careRecommendations: Array<(
      { __typename?: 'CareRecommendationNode' }
      & Pick<Types.CareRecommendationNode, 'uuid' | 'onboarding' | 'state' | 'modalityPreference' | 'startedAt' | 'recommendation' | 'recommendedAt' | 'acceptedAt'>
      & { topicSelections: Array<(
        { __typename?: 'TopicSelectionNode' }
        & Pick<Types.TopicSelectionNode, 'uuid'>
        & { topicOfFocus: (
          { __typename?: 'TopicOfFocusNode' }
          & Pick<Types.TopicOfFocusNode, 'uuid' | 'name' | 'image'>
        ), subtopicSelections: Array<(
          { __typename?: 'SubtopicSelectionNode' }
          & Pick<Types.SubtopicSelectionNode, 'uuid'>
          & { subtopicOfFocus: (
            { __typename?: 'SubtopicOfFocusNode' }
            & Pick<Types.SubtopicOfFocusNode, 'uuid' | 'name' | 'symptoms'>
            & { subtopicSymptoms: Array<(
              { __typename?: 'SubtopicOfFocusSymptomNode' }
              & Pick<Types.SubtopicOfFocusSymptomNode, 'uuid' | 'name' | 'displayOrder' | 'isActive'>
            )> }
          ) }
        )> }
      )> }
    )>, phq9Access?: Types.Maybe<(
      { __typename?: 'Phq9Access' }
      & Pick<Types.Phq9Access, 'lastAccess' | 'phq9SelfHarmScore' | 'showTakeOverScreen'>
    )>, featuredBenefits?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'FeaturedBenefit' }
      & Pick<Types.FeaturedBenefit, 'id' | 'uuid' | 'title' | 'providerName' | 'phoneNumber' | 'description' | 'link' | 'imageUrl' | 'color'>
    )>>>, sharedPreferences?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'AccountSharedPreferencesRecordNode' }
      & SharedPreferencesFragment
    )>>>, notificationPreferences?: Types.Maybe<(
      { __typename?: 'NotificationPreferencesNode' }
      & NotificationPreferencesFragment
    )> }
  )> }
);

export const SharedPreferencesFragmentDoc = gql`
    fragment SharedPreferences on AccountSharedPreferencesRecordNode {
  key
  value
}
    `;
export const NotificationPreferencesFragmentDoc = gql`
    fragment NotificationPreferences on NotificationPreferencesNode {
  chatNotifications
  courseReminders
  dailyPauseRemindersEmail
  dailyPauseRemindersPush
  wellBeingReminders
}
    `;
export const GetMemberInformationQueryDocument = gql`
    query getMemberInformationQuery {
  me {
    id
    uuid
    defaultVisitDuration
    zipCode
    phoneNumber
    avatar
    firstName
    lastName
    email
    eligiblePersonEmail
    isActiveCobraRifMember
    isCompanyHpiEnabled
    isCompanyPsychiatryEnabled
    newEmailAddressNotConfirmed
    parentUuid
    isDependent
    birthDate
    localTimezone
    country
    city
    state
    languagePreferences
    onboardingStatus
    role
    availability
    emailConfirmed
    joinedAt
    registrationSource
    ssoOnly
    visitsRemaining {
      therapyVisitsRemaining
      coachingVisitsRemaining
    }
    company {
      name
      uuid
      hrEmail
      resetDate
      coveredTherapyVisits
      coveredCoachingVisits
      ssoOnly
      dependentInvitationFeature
    }
    careRecommendations {
      uuid
      onboarding
      state
      modalityPreference
      startedAt
      recommendation
      recommendedAt
      acceptedAt
      topicSelections {
        uuid
        topicOfFocus {
          uuid
          name
          image
        }
        subtopicSelections {
          uuid
          subtopicOfFocus {
            uuid
            name
            symptoms
            subtopicSymptoms {
              uuid
              name
              displayOrder
              isActive
            }
          }
        }
      }
    }
    phq9Access {
      lastAccess
      phq9SelfHarmScore
      showTakeOverScreen
    }
    featuredBenefits {
      id
      uuid
      title
      providerName
      phoneNumber
      description
      link
      imageUrl
      color
    }
    sharedPreferences {
      ...SharedPreferences
    }
    notificationPreferences {
      ...NotificationPreferences
    }
  }
}
    ${SharedPreferencesFragmentDoc}
${NotificationPreferencesFragmentDoc}`;
export type GetMemberInformationQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMemberInformationQueryQuery, GetMemberInformationQueryQueryVariables>, 'query'>;

    export const GetMemberInformationQueryComponent = (props: GetMemberInformationQueryComponentProps) => (
      <ApolloReactComponents.Query<GetMemberInformationQueryQuery, GetMemberInformationQueryQueryVariables> query={GetMemberInformationQueryDocument} {...props} />
    );
    
export type GetMemberInformationQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMemberInformationQueryQuery, GetMemberInformationQueryQueryVariables>
    } & TChildProps;
export function withGetMemberInformationQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMemberInformationQueryQuery,
  GetMemberInformationQueryQueryVariables,
  GetMemberInformationQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMemberInformationQueryQuery, GetMemberInformationQueryQueryVariables, GetMemberInformationQueryProps<TChildProps, TDataName>>(GetMemberInformationQueryDocument, {
      alias: 'getMemberInformationQuery',
      ...operationOptions
    });
};

/**
 * __useGetMemberInformationQueryQuery__
 *
 * To run a query within a React component, call `useGetMemberInformationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberInformationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberInformationQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMemberInformationQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMemberInformationQueryQuery, GetMemberInformationQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMemberInformationQueryQuery, GetMemberInformationQueryQueryVariables>(GetMemberInformationQueryDocument, options);
      }
export function useGetMemberInformationQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMemberInformationQueryQuery, GetMemberInformationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMemberInformationQueryQuery, GetMemberInformationQueryQueryVariables>(GetMemberInformationQueryDocument, options);
        }
export type GetMemberInformationQueryQueryHookResult = ReturnType<typeof useGetMemberInformationQueryQuery>;
export type GetMemberInformationQueryLazyQueryHookResult = ReturnType<typeof useGetMemberInformationQueryLazyQuery>;
export type GetMemberInformationQueryQueryResult = ApolloReactCommon.QueryResult<GetMemberInformationQueryQuery, GetMemberInformationQueryQueryVariables>;